import { faGithub, faLinkedin } from '@fortawesome/free-brands-svg-icons';
import { faCode } from '@fortawesome/free-solid-svg-icons';

const icons = [faCode, faGithub, faLinkedin];

export { icons };
